import { render, staticRenderFns } from "./BillDetailDialog.vue?vue&type=template&id=52c964b4&scoped=true"
import script from "./BillDetailDialog.vue?vue&type=script&lang=js"
export * from "./BillDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./BillDetailDialog.vue?vue&type=style&index=0&id=52c964b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c964b4",
  null
  
)

export default component.exports